import React from "react";
import BlockInterface from '../editable_interface/BlockInterface/BlockInterface';
import Banner from '../components/Banner/Banner.js'
import './style.css';

export default function Home() {
    /////////////////////////////////////////////////////////////////////////////
    let image_name = "home.mp4";
    let is_video = true;
    /////////////////////////////////////////////////////////////////////////////
    return (
        <>
            <Banner src={image_name} isVideo={is_video}></Banner>
            {/* Banner aspect ration about 20:9 */}
            <BlockInterface pageName="Home"></BlockInterface>
        </>
    );
}
